var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 529 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.788 443.719C200.772 464.919 134.286 496.5 56.2859 457C-21.7141 417.5 -25.5567 119.487 96.7576 31.4675C219.072 -56.5525 445.052 49.3058 416.879 234.439C388.706 419.572 338.803 422.52 269.788 443.719Z",
    fill: "#0078FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.932 315.358C457.276 266.444 465.276 246.139 497.485 264.923C529.693 283.706 544.621 377.46 501.303 442.721C457.984 507.982 332.038 462.22 339.926 411.629C347.814 361.039 384.588 364.273 420.932 315.358Z",
    fill: "#FFDEE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.2ada468ba4df5cbbca06c3d952f090bd.svg";
export { ForwardRef as ReactComponent };